import { useEffect, useRef } from "react";

// The MUI DatePicker calendar renders in a DOM portal outside the modal ref.
// Without this check, any mousedown on the calendar triggers the "outside click"
// callback and closes the modal before the user can select a date.
const MUI_PICKER_SELECTOR =
  '[class*="MuiPickersPopper"], [class*="MuiDateCalendar"], [class*="MuiDayCalendar"], [class*="MuiPickersDay"]';

export const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      if (target.closest(MUI_PICKER_SELECTOR)) return;
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
};
